import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=f4575ff8&scoped=true&"
import script from "./InfoDetails.vue?vue&type=script&lang=js&"
export * from "./InfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=f4575ff8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4575ff8",
  null
  
)

export default component.exports